import { withNamespaces } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import PPWRReadinessScore from './components/PPWRReadinessScore';
import SummaryWidget from './components/SummaryWidget';
import SummaryWidgetsSkeleton from './components/SummaryWidgetsSkeleton';
import useSummaryWidgets from './hooks/useSummaryWidgets';

const SummaryWidgets = ({
    t,
}) => {
    const {
        isLoading,
        isFetching,
        isError,
        widgets,
    } = useSummaryWidgets({ t });

    if (isLoading || isFetching) {
        return <SummaryWidgetsSkeleton />;
    }

    if (isError || !widgets) {
        return null;
    }

    return (
        <Row className="g-3">
            <Col xs="12" xl="5" md="12" lg="4">
                <PPWRReadinessScore
                    t={t}
                    readinessScore={widgets.readinessScore}
                    reviewItems={widgets.reviewItems}
                />
            </Col>

            <Col xs="12" xl="7" md="12" lg="8">
                <Row className="g-3">
                    <Col xs="12" sm="6" lg="3">
                        <SummaryWidget {...widgets.compliance} />
                    </Col>

                    <Col xs="12" sm="6" lg="3">
                        <SummaryWidget {...widgets.readinessPercentage} />
                    </Col>

                    <Col xs="12" sm="6" lg="3">
                        <SummaryWidget {...widgets.activeSuppliers} />
                    </Col>

                    <Col xs="12" sm="6" lg="3">
                        <SummaryWidget {...widgets.lastUpdated} />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default withNamespaces()(SummaryWidgets);
